module.exports = __webpack_public_path__ + "img/com.codeway.scannerplus-staging.7811a9b9.png";